<span [matTooltip]="text" [matTooltipPosition]="place" matTooltipClass="tooltip-with-triangle">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.3 9.1H7.7V10.5H6.3V9.1ZM6.3 3.5H7.7V7.7H6.3V3.5ZM6.993 0C3.129 0 0 3.136 0 7C0 10.864 3.129 14 6.993 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 6.993 0ZM7 12.6C3.906 12.6 1.4 10.094 1.4 7C1.4 3.906 3.906 1.4 7 1.4C10.094 1.4 12.6 3.906 12.6 7C12.6 10.094 10.094 12.6 7 12.6Z" fill="#717172"/>
    </svg>
</span>
